import { render, staticRenderFns } from "./app-live-list-pub.vue?vue&type=template&id=24d2938b&scoped=true&"
import script from "./app-live-list-pub.vue?vue&type=script&lang=js&"
export * from "./app-live-list-pub.vue?vue&type=script&lang=js&"
import style0 from "./app-live-list-pub.vue?vue&type=style&index=0&id=24d2938b&lang=scss&scoped=true&"
import style1 from "./app-live-list-pub.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d2938b",
  null
  
)

export default component.exports